var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.Renewal },
                  model: {
                    value: _vm.paramsData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_prod", $$v)
                    },
                    expression: "paramsData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    multiple: "",
                    clearable: "",
                    "collapse-tags": "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectServer")
                  },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                _vm._l(_vm.serverLists, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.serverName, value: item.serverID }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("reportUserUserId")
                },
                model: {
                  value: _vm.paramsData.report_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "report_user_id", $$v)
                  },
                  expression: "paramsData.report_user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("reportUserRoleId")
                },
                model: {
                  value: _vm.paramsData.report_role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "report_role_id", $$v)
                  },
                  expression: "paramsData.report_role_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("reportedUserUserId")
                },
                model: {
                  value: _vm.paramsData.reported_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "reported_user_id", $$v)
                  },
                  expression: "paramsData.reported_user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("reportedUserRoleId")
                },
                model: {
                  value: _vm.paramsData.reported_role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "reported_role_id", $$v)
                  },
                  expression: "paramsData.reported_role_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("reportType")
                  },
                  model: {
                    value: _vm.paramsData.report_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "report_type", $$v)
                    },
                    expression: "paramsData.report_type"
                  }
                },
                _vm._l(_vm.reportTypeList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "game", label: _vm.$t("game") }
          }),
          _c("el-table-column", {
            attrs: { prop: "env", label: _vm.$t("environment") }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_id", label: _vm.$t("serverId") }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_name",
              label: _vm.$t("serverName"),
              width: "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "report_user_id",
              label: _vm.$t("reportUserUserId"),
              width: "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "report_role_id",
              label: _vm.$t("reportUserRoleId"),
              width: "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reported_user_id",
              label: _vm.$t("reportedUserUserId"),
              width: "140"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reported_role_id",
              label: _vm.$t("reportedUserRoleId"),
              width: "140"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "report_type",
              label: _vm.$t("reportType"),
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      _vm._l(
                        row.report_type ? row.report_type.split(",") : [],
                        function(typeId) {
                          return _c(
                            "div",
                            {
                              key: typeId,
                              staticStyle: { "margin-right": "8px" }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.reportTypeMap[typeId] ||
                                      _vm.$t("unknownType")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        }
                      ),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "report_content",
              label: _vm.$t("reportContent"),
              width: "180"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "created_at",
              label: _vm.$t("createTime"),
              width: "170"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: _vm.$t("status") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("pending")))])
                      : _vm._e(),
                    row.status == 1
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("processed")))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "resolved_time",
              label: _vm.$t("processTime"),
              width: "170"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "resolve_type", label: _vm.$t("processType") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.resolve_type == 1
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("banAccount")))])
                      : _vm._e(),
                    row.resolve_type == 2
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("mute")))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "admin_name", label: _vm.$t("processAdmin") }
          }),
          _c("el-table-column", {
            attrs: { prop: "reason", label: _vm.$t("processReasonRemark") }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "100", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status != 1
                      ? _c("div", { staticClass: "x-c" }, [
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.addAbuse.open(row)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("ban")))]
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "text-align": "center" },
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
      }),
      _c("addAbuse", {
        ref: "addAbuse",
        attrs: { prod: { is_prod: _vm.paramsData.is_prod } },
        on: { change: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }